import React, { useState, useEffect, useContext } from 'react';
import TitleBar from '../components/TitleBar.jsx';
import '../styles/home_navigation.css';
import ProjectsIcon from '../images/projects.svg';
import ProjectsReportsIcon from '../images/reports.svg';
import VoiceIcon from '../images/voice-icon.svg';
import CostCenterIcon from '../images/costcenter-icon.svg';
import PromptIcon from '../images/prompt-icon.svg';
import ReleaseNotificationsIcon from '../images/release-notifications.svg';
import CampaignIcon from '../images/campaigns.png';
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { unfolder } from '../lib'
import Tutor from '../components/common/Tutor/Tutor.jsx';
import { useTranslate } from '../lib';
const HomeNavigation = ()=>{
    const [role, setRole] = useState(0)

    useEffect(() => {
        console.log("Ingreso al rol")
        setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)        
    }, [])
    const { t } = useTranslate();
    const tutorialSteps = [
        { elementId: 'projects-home-link', text: t('tutorial.accessProjects') },
        { elementId: 'report-tp', text: t('tutorial.seeReports') },
        { elementId: 'cost_center', text: t('tutorial.costCenter') },
        { elementId: 'prompt-library-link', text: t('tutorial.promptLibrary') },
        { elementId: 'voice-tp', text: t('tutorial.voices') },
        { elementId: 'release-notifications', text: t('tutorial.releaseNotifications') },
    ];
    return <div className='general-container'>
        <TitleBar />
        <div className='primary-container d-flex flex-row flex-wrap justify-content-between mt-3'>
            {role !== 4 && 
            <Link to={'/projects'} className='box-home' id="projects-home-link">
                <img src={ProjectsIcon} alt="Projects Icon" />
                <span style={{marginTop: 15}}>{t('common.projects')}</span>
            </Link>
            }
            <Tooltip style={{fontSize: 13, maxWidth: 250}}
                  anchorId="projects-home-link" content={t('menu.campaignHomeNavigationTooltip')} place="top" />

            <Link id='report-tp' to={'/project-reports'} className='box-home'>
                <img src={ProjectsReportsIcon} alt="Projects Reports Icon" />
                <span style={{marginTop: 15}}>{t('reports.reports')}</span>
            </Link>
            <Tooltip style={{fontSize: 13, maxWidth: 160}} anchorId="report-tp" content={t('reports.reports')} place="top" />

            <Tooltip anchorId="cost_center" content={t('menu.costCenter')} place="top" style={{fontSize: 13, maxWidth: 160}} />
            <Link id='cost_center' to={'/cost_center'} className='box-home'>
                <img src={CostCenterIcon} alt="CostCenter Icon" />
                <span style={{marginTop: 15}}>{t('menu.costCenter')}</span>
            </Link>

            <Tooltip style={{fontSize: 13, maxWidth: 200}}
                anchorId="prompt-library-link" content={`Default Prompt Data`} place="top" />
            {role !== 4 &&
            <Link to={'/prompt-library'} className='box-home' id='prompt-library-link'>
                <img src={PromptIcon} alt="Projects Icon" />
                <span style={{marginTop: 15}}>{t('menu.genai.promptLibrary')}</span>
            </Link>
            }
            
            <Tooltip anchorId="voice-tp" content={t('menu.voicesCustomaizables')} place="top"
                style={{fontSize: 13, maxWidth: 160}} />
            {role !== 4 &&
            <Link id='voice-tp' to={'/Voices'} className='box-home'>
                <img src={VoiceIcon} alt="Voice Icon" />
                <span style={{marginTop: 15}}>{t('menu.voicesCustomaizables')}</span>
            </Link>
            }

            <Tooltip anchorId="release-notifications" content={t('menu.releaseNotifications')} place="top"
                style={{fontSize: 13, maxWidth: 160}} />
            {role === 6 && <Link id='release-notifications' to={'/release-notifications'} className='box-home'>
                <img src={ReleaseNotificationsIcon} alt="Voice Icon" />
                <span style={{marginTop: 15}}>{t('menu.releaseNotifications')}</span>
            </Link>
            }

            {/* <Tooltip anchorId="campaigns" content={t('common.campaigns')} place="top"
                style={{fontSize: 13, maxWidth: 160}} />
            {role !== 4 && <Link id='campaigns' to={'/campaigns'} className='box-home'>
                <img src={CampaignIcon} alt="Campaign Icon" />
                <span style={{marginTop: 15}}>{t('common.campaigns')}</span>
            </Link>
            } */}

        </div>

        <Tutor steps={tutorialSteps} viewKey="HomeNavigation" />
    </div>
}

export default HomeNavigation;